.statsBar {
  display: flex;
  justify-content: space-between;
  font-size: 1.5rem;
  position: absolute;
  left: 32px;
  right: 32px;
  padding-top: 18px;
}

.clock {
  margin-right: 12px;
}

.lives {
  display: flex;
  column-gap: 4px;
}
